import React from "react";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import Box from "@mui/material/Box";
import useStyled from "../../hooks/useStyled";
const { styled } = useStyled();

const ContentContainer = styled(SFStack)(({ theme }) => ({
  width: "100%",
  height: "100%",
}));

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasMinWidth",
})(({ theme, hasMinWidth, }) => ({
  background: "linear-gradient(180deg, rgba(46, 46, 56, 0.4) 0%, rgba(35, 35, 47, 0.4) 100%)",
  borderRadius: theme.spacing(1.5),
  overflow: "hidden",
  ...(hasMinWidth && {
    [theme.breakpoints.down("md")]: {
      width: 220,
      height: 120,
    },
    [theme.breakpoints.up("md")]: {
      width: 220,
      height: 120,
    },
    [theme.breakpoints.up("lg")]: {
      width: 320,
      height: 170,
    },
  }),
}));

const SFSkeletonThumbnail = ({ hasMinWidth = true, title }) => {
  return (
    <Container hasMinWidth={true}>
      <ContentContainer alignItems="center" justifyContent="center">
        {title && (
          <SFTypography variant="courseCardTitle">{title}</SFTypography>
        )}
      </ContentContainer>
    </Container>
  );
};

export default SFSkeletonThumbnail;
